module.exports = __webpack_public_path__ + "img/ug.8bf8f7e4.svg";